import { useLiveAccountState } from 'View/live-account/state';

const useResetAllState = () => {
  const { resetState, resetFilterState } = useLiveAccountState();

  const onResetAllState = () => {
    resetState();
    resetFilterState();
  };

  return onResetAllState;
};

export default useResetAllState;
